import { NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IFormInputMask } from '@shared/core';
import { LocalizationPipe } from '@shared/modules/localization';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NgxMaskConfig, NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { IFormFieldTextareaField } from '../../models';
import {
  BaseFormFieldComponent,
  baseProviderComponent,
} from '../base-form-field.component';

const maskBaseConfig: Partial<NgxMaskConfig> = {
  clearIfNotMatch: false,
};

@Component({
  selector: 'ui-form-textarea',
  templateUrl: './form-textarea.component.html',
  styleUrl: './form-textarea.component.scss',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    NgIf,
    NzFormModule,
    NzInputModule,
    FormsModule,
    NgxMaskDirective,
    LocalizationPipe,
  ],
  providers: [
    ...baseProviderComponent(UIFormTextarea),
    provideNgxMask(maskBaseConfig),
  ],
})
export class UIFormTextarea extends BaseFormFieldComponent {
  @Input() override value?: string = '';
  @Input() override set config(configValue: IFormFieldTextareaField) {
    this.label = configValue.label;
    this.placeholder = configValue.placeholder ?? '';
    this.minRows = configValue.minRows ?? 2;
    this.maxRows = configValue.maxRows ?? 6;
    this.hideLabel = configValue.hideLabel ?? false;
  }
  @Input() minRows = 2;
  @Input() maxRows = 6;

  maskConfig?: IFormInputMask;

  override get errorTip(): string {
    // Check if there are any errors, return early if none.
    if (!this.control?.errors) {
      return '';
    }

    // Directly access the first error key and value.
    const [firstErrorKey, firstErrorValue] = Object.entries(
      this.control.errors
    )[0];

    // Check for 'mask' error specifically.
    if (firstErrorKey === 'mask') {
      // Return the mask error text if it exists, otherwise use a default message.
      return this.maskConfig?.errorText || 'form.error.invalidData';
    }

    // If the error value is a string, return it, otherwise use a default message.
    return typeof firstErrorValue === 'string'
      ? firstErrorValue
      : typeof firstErrorValue === 'object'
      ? firstErrorValue.translation
      : 'form.error.required';
  }

  onBlur(): void {
    this.onTouched();
  }

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    let text = target.value;
    if (this.maskConfig?.formatter) {
      text = this.maskConfig.formatter(text);
    }
    this.value = text;
    this.onChange(this.value);
    this.updateControlValidity(); // Ensure control state is updated
  }
}
